import { Fragment } from 'react';
import { HomeSmile } from 'assets/icons';
import { classnames } from 'helpers/utils';
import type { Breadcrumb } from 'helpers/vault-breadcrumbs';
import styles from './breadcrumb-trail.module.scss';

interface BreadcrumbTrailProps {
  crumbs: Breadcrumb[];
  className?: string;
}

// The "Dashboard / Albums / Trip" style trail shared by the vault top bar and
// the older navbars. Crumbs without `onClick` stand for the current screen.
export const BreadcrumbTrail = ({
  crumbs,
  className,
}: BreadcrumbTrailProps) => (
  <nav
    className={classnames(styles.breadcrumb, className ?? '')}
    aria-label="Breadcrumb"
  >
    {crumbs.map((crumb, index) => {
      // The first crumb (the trail's root) carries the home icon whether or
      // not it's the current screen.
      const icon = index === 0 && (
        <HomeSmile className={styles.breadcrumbHomeIcon} />
      );
      const label = (
        <span className={styles.breadcrumbLabel} title={crumb.label}>
          {crumb.label}
        </span>
      );
      return (
        // Labels alone aren't unique (an album can be named "Albums").
        // eslint-disable-next-line react/no-array-index-key
        <Fragment key={`${index}-${crumb.label}`}>
          {index > 0 && <span className={styles.breadcrumbSeparator}>/</span>}
          {crumb.onClick ? (
            <button
              type="button"
              className={styles.breadcrumbLink}
              onClick={crumb.onClick}
            >
              {icon}
              {label}
            </button>
          ) : (
            <span className={styles.breadcrumbCurrent} aria-current="page">
              {icon}
              {label}
            </span>
          )}
        </Fragment>
      );
    })}
  </nav>
);
